export default __webpack_public_path__ + "static/media/mobile_apps.46fafe6f.png";